module.exports = __webpack_public_path__ + "img/gerch-home.2fb3a339.jpg";